/**
 * Режим биржи из admin_config.json (task.txt, 2026-09-28) — одна точка правды
 * для фронта. Зеркало exchangeMode() из TG-BOT/src/adminConfig.js: админ может
 * записать в конфиг и булево, и строку, а читают его три разных места (админка,
 * раздел «Биржи», публичный конфиг при подключении ключей), поэтому нормализуем
 * здесь, а не в каждом экране по-своему.
 *
 *   'on'  — биржа показывается и подключается (обычная карточка);
 *   'dev' — карточка ОСТАЁТСЯ в разделе «Биржи», но не кликабельна
 *           и подписана «в разработке»;
 *   'off' — биржи нет в интерфейсе вообще.
 */

/**
 * Значение из конфига → 'on' | 'dev' | 'off'.
 *
 * Отсутствие ключа (undefined/null) — это НЕ «скрыта»: до появления режимов
 * такая биржа показывалась, и публичный конфиг приходит не целиком (в сторе
 * лежит урезанный дефолт до ответа /api/app-config). Иначе карточки KuCoin и
 * BingX мигали бы в списке и исчезали при любой осечке с конфигом.
 */
export function exchangeMode(value) {
  if (value === 'dev' || value === 'development') return 'dev'
  if (value === false || value === 'off' || value === 'false' || value === 0) return 'off'
  if (value === undefined || value === null) return 'on'
  return value ? 'on' : 'off'
}

/** Обратное преобразование — что записать в конфиг. */
export function exchangeModeValue(mode) {
  if (mode === 'dev') return 'dev'
  return mode === 'off' ? false : true
}

/** Режим конкретной биржи из публичного конфига приложения. */
export function exchangeModeOf(appConfig, id) {
  return exchangeMode(appConfig?.exchanges?.[id])
}

/** Биржа вообще видна в разделе «Биржи» (включая «в разработке»). */
export function isExchangeVisible(appConfig, id) {
  return exchangeModeOf(appConfig, id) !== 'off'
}

/**
 * Карточка заблокирована режимом «в разработке».
 *
 * Юзера, у которого на этой бирже УЖЕ есть ключи или созданный бот, не
 * запираем: он должен иметь доступ к своим ключам и управлению ботом, даже
 * если биржа ушла в разработку. Блокировка — только для тех, кто ещё не
 * подключился (extra.connected / extra.hasBot считает вызывающий экран).
 */
export function isExchangeDevLocked(appConfig, id, { connected = false, hasBot = false } = {}) {
  return exchangeModeOf(appConfig, id) === 'dev' && !connected && !hasBot
}

/**
 * Биржа открыта для НОВЫХ ботов — только режим 'on' (2026-10-26).
 *
 * «В разработке» значит «бота здесь создать нельзя»: ключи на такую биржу не
 * подключаются (POST /api/exchanges/connect отвечает 403), и созданный бот не
 * заторгует — движку нечем подписывать ордера. Проверка есть и на бэкенде
 * (POST /api/bots), здесь она нужна, чтобы биржа даже не предлагалась в форме
 * создания. Уже созданных ботов это не касается: ими управляют через
 * шестерёнку, режим им не мешает.
 */
export function isExchangeBookable(appConfig, id) {
  return exchangeModeOf(appConfig, id) === 'on'
}
